import api from "./api";

export interface NotaPessoal {
  id: string;
  texto: string;
  concluido: boolean;
  arquivado: boolean;
  ordem: number;
  criadoEm: string;
  atualizadoEm: string;
}

export async function listarNotasPessoais(opts?: { arquivadas?: boolean }) {
  const r = await api.get(`/notas-pessoais${opts?.arquivadas ? "?arquivadas=1" : ""}`);
  return r.data.data as NotaPessoal[];
}

export async function criarNotaPessoal(texto: string) {
  const r = await api.post("/notas-pessoais", { texto });
  return r.data.data as NotaPessoal;
}

export async function atualizarNotaPessoal(
  id: string,
  dados: Partial<{ texto: string; concluido: boolean; arquivado: boolean; ordem: number }>,
) {
  const r = await api.patch(`/notas-pessoais/${id}`, dados);
  return r.data.data as NotaPessoal;
}

export async function excluirNotaPessoal(id: string) {
  await api.delete(`/notas-pessoais/${id}`);
}
